import React from 'react';

const State = () => {
    return (
        <div className='min-h-[40vh] w-full flex items-center justify-center'>
            <div className="stats flex flex-col lg:flex-row">

                <div className="stat place-items-center">
                    <div className="stat-title">Items Delivered</div>
                    <div className="stat-value">897</div>
                </div>

                <div className="stat place-items-center">
                    <div className="stat-title">Happy Customer</div>
                    <div className="stat-value text-secondary">700</div>
                </div>

                <div className="stat place-items-center">
                    <div className="stat-title">Rating</div>
                    <div className="stat-value">4.8</div>
                </div>

            </div>
        </div>
    );
};

export default State;